<template>
  <w-sliding-popup type="full" ref="slidingPopup" title="원본 데이터 차트" :default-content="false" @close="onPopupClose">
    <div slot="title">
       <w-datetime-range-button ref="datetimeRangeBtn" :maxDayValue="31" :isRelativeOnly="true"/>
    </div>
    <div id="wrapper" slot="content" >
      <drag-zone class="horizontal-zone">
        <drag-content class="horizontal-zone--content popup-horiozontal-zone--frame-side">
          <aside>
            <div class="popup-category-group">
              <div class="search">
                <w-search-field @search="filterTree"/>
              </div>
              <div style="margin-top:15px; height:calc(100% - 135px); width:100%;" v-loading="logicalTreeLoading">
                <el-scrollbar>
                  <w-logical-tree ref="logicalTree" @clickNode="onClickTreeNode" />
                </el-scrollbar>
              </div>
            </div>
          </aside>
        </drag-content>
        <drag-handle class="horizontal-zone--handle"></drag-handle>
        <drag-content id="page-wrapper" class="page horizontal-zone--content horiozontal-zone--frame-main">
          <div class="page-container">
            <div class="main-height left-col-wrapper" slot="mainContent">
              <!-- 자원 목록 -->
              <w-rsc-tree ref="rscTree" :selected-tree-node="selectedTreeNode" @dragstart="onDragNode" @dragend="onDragEndNode" @closeTree="onClickRscCloseButton"/>
              <!-- 차트 영역 -->
              <div class="page-container-right-col">
                <div class="full-wrapper" :style="chartWrapperStyle">
                  <el-scrollbar :ref="scrollbarRef">
                    <div class="full" style="position:relative;">
                      <div class="drop-wrapper active" >
                        <w-skcc-chart-drop-zone-view ref="skccDropzoneView" :dropzoneVisible="dropzoneVisible" :selectedTreeNode="selectedTreeNode"
                          @setChartList="setChartList" :initChart="selectedChart" />
                      </div>
                    </div>
                  </el-scrollbar>
                </div>
              </div>
              <w-scroll-top-button :visible="enableScollTop" @move-scroll-top="moveScrollTop" />
            </div>
          </div>
        </drag-content>
      </drag-zone>
    </div>
  </w-sliding-popup>
</template>

<script>
import { mapGetters } from 'vuex';
import { forEach, clone, filter, find, cloneDeep } from 'lodash';
import { isEmpty } from '@/utils/basic';
import ScrollbarMixin from '@/mixins/scrollbar';
import WDatetimeRangeButton from '@/components/button/DatetimeRangeButton';
import WSearchField from '@/components/form/SearchField';
import DragZone from '@/components/external/VueDragZone/zone';
import DragHandle from '@/components/external/VueDragZone/handle';
import DragContent from '@/components/external/VueDragZone/content';
import WSkccChartDropZoneView from './SkccChartDropZoneView';
import WLogicalTree from '../../tree/LogicalTree';
import WRscTree from '../..//tree/RscTree';

export default {
  name: 'WSkccChartView',
  mixins: [ScrollbarMixin],
  components: {
    WDatetimeRangeButton,
    WSkccChartDropZoneView,
    WLogicalTree,
    WRscTree,
    WSearchField,
    DragZone,
    DragHandle,
    DragContent,
  },
  data() {
    return {
      title: '뒤로 가기',
      showRsc: false,
      dropzoneVisible: false,
      selectedTreeNode: {},
      chartRscList: [],
      selectedChart: {},
      parentChartViewParams: {}, // 기존 차트 분석 조회 기간 파라미터
      parentChartViewIsRelative: false, // 기존 차트 분석 조회 기간의 isRelative 값
    };
  },
  computed: {
    chartWrapperStyle() {
      return this.showRsc ? {
        marginLeft: '240px',
      } : {
        marginLeft: 0,
      };
    },
    logicalTreeLoading() {
      return this.$store.state.common.logicalTreeLoading;
    },
    ...mapGetters(['analysisDateParams', 'isRelativeAnalysisDate']),
  },
  methods: {
    /**
     * 그려진 차트의 정보를 공유한다.
     * @param  {[type]} chartRscList [description]
     * @author jda
     */
    setChartList(chartRscList) {
      this.chartRscList = chartRscList;
    },
    open({ managetypeId, objId, rsctypeId, rscId, rscKey }) {
      this.setChartList([]);

      this.selectedChart = {
        items: [{
          managetypeId,
          objId,
          rsctypeId,
          rscId,
          rscKey,
          orderbyIndex: 1,
        }],
        visible: true,
        added: true,
      };

      this.$refs.slidingPopup.open();
      this.$refs.datetimeRangeBtn.setDefaultDatetime();

      this.parentChartViewParams = cloneDeep(this.$store.state.performance.analysisDateData);
      this.parentChartViewIsRelative = cloneDeep(this.isRelativeAnalysisDate);
      this.$store.dispatch('setAnalysisIsRelativeData', true);
    },
    /**
     * 트리 노드 선택시 해당 관리대상의 자원 정보들을 가져온다.
     * @param  {[type]} data [description]
     * @param  {[type]} node [description]
     * @return {[type]}      [description]
     * @author jda
     */
    onClickTreeNode(data) {
      this.selectedTreeNode = data;

      if (data.type !== 'obj') {
        return;
      }

      this.showRsc = true;
      this.$refs.rscTree.showTree();
    },
    /**
     * 트리나 자원 드래그 시 dropzone 생성
     * @param  {[type]} node [description]
     * @return {[type]}      [description]
     * @author jda
     */
    onDragNode(node) {
      if (!isEmpty(node.data) && node.data.type === 'obj') { // 물리 그룹 트리 제공으로 isLeaf로 기준이 되지 못함.
        return;
      }

      this.dropzoneVisible = true;
      const CHART_MAX_COUNT = 2;
      const SERIES_MAX_COUNT = 2;
      const rscUnit = isEmpty(node.rscUnit) ? null : node.rscUnit;
      const isGroup = isEmpty(node.rscId) && !this.isObj(node.data);

      if (!isEmpty(node.rscId)) {
        this.setClassExistingRsc(node);
      }

      const chartContainers = document.getElementsByClassName('list-analytics skcc-chart');
      forEach(chartContainers, (container, idx) => {
        if (container.className.indexOf('drop-area') < 0) {
          const chartRscUnit = container.getAttribute('rscUnit');
          const chartSeriesCount = this.chartRscList[idx].items.length;

          if ((!isEmpty(chartRscUnit) && chartRscUnit !== rscUnit) || isGroup || (chartSeriesCount >= SERIES_MAX_COUNT)) {
            container.className += ' drop-area';
          } else {
            container.className += ' drop-area blue';
          }
        }
      });

      const dropzoneContainers = document.getElementsByClassName('dropzone-area skcc-dropzone');
      forEach(dropzoneContainers, (container) => {
        if (this.chartRscList.length >= CHART_MAX_COUNT || isGroup) {
          container.className += ' drop-area';
        } else {
          container.className += ' drop-area blue';
        }
      });
    },
    /**
     * 드래그 노드를 drop했을 경우 dropzone의 스타일을 해제한다.
     * @return {[type]} [description]
     * @author jda
     */
    onDragEndNode() {
      this.dropzoneVisible = false;
      const chartContainers = document.getElementsByClassName('list-analytics skcc-chart');
      forEach(chartContainers, (container) => {
        const className = container.className;
        container.className = className.replace(/ drop-area| blue| green/g, '');
      });

      const dropzoneContainers = document.getElementsByClassName('dropzone-area skcc-dropzone');
      forEach(dropzoneContainers, (container) => {
        const className = container.className;
        container.className = className.replace(/ drop-area| blue| green/g, '');
      });
    },
    /**
     * 자원 drag시 해당 자원이 이미 추가된 차트에는 drop하지 못하도록 한다.
     * @param  {[type]} node [description]
     * @return {[type]}      [description]
     * @author jda
     */
    setClassExistingRsc(node) {
      const selectedTreeNode = this.selectedTreeNode;
      const { managetypeId, rsctypeId, rscId } = node;
      const rscInfo = {
        managetypeId,
        rsctypeId,
        rscId,
      };

      Object.assign(rscInfo, {
        objId: selectedTreeNode.obj.objId,
        rscKey: isEmpty(node.rscKey) ? '_' : node.rscKey,
      });

      const visibleChartList = [];

      // 삭제된 시리즈를 제외한다.
      this.chartRscList.forEach((chartObject) => {
        const chart = clone(chartObject);
        const visibleSeries = filter(chartObject.items, (record) => isEmpty(record.deleted) || !record.deleted);
        chart.items = visibleSeries;
        visibleChartList.push(chart);
      });

      // 해당 자원이 이미 추가됬으면 drop하지 못한다.
      const existingRscList = filter(visibleChartList, (chartObject) => find(chartObject.items, rscInfo));
      existingRscList.forEach((record) => {
        const container = record.chart.container.closest('[class="list-analytics skcc-chart"]');
        container.className += ' drop-area';
      });
    },
    /**
     * 자원 목록 컴포넌트를 숨김처리한다.
     * @return {[type]} [description]
     * @author jda
     */
    onClickRscCloseButton() {
      this.showRsc = false;
    },
    filterTree(value) {
      this.$refs.logicalTree.filterTree(value);
    },
    onPopupClose() {
      this.$store.dispatch('setAnalysisDateData', this.parentChartViewParams);
      this.$store.dispatch('setAnalysisIsRelativeData', this.parentChartViewIsRelative);

      this.selectedChart = {};
      this.$refs.rscTree.onClickRscCloseButton();

      this.$emit('closeSkccChartView');
    },
  },
};
</script>

<style scoped>
  .popup-category-group {
    position: relative;
    width: 256px;
    height: 100%;
    padding: 18px;
  }

  .popup-horiozontal-zone--frame-side {
    position: relative;
    width: 256px;
    height: 100%;
    min-width: 256px;
  }

  #wrapper aside {
    width: 256px;
    min-width: 256px;
  }

  #page-wrapper {
    width: calc(100% - 256px) !important;
    padding-top: 0 !important;
  }

  .full-wrapper {
    height: calc(100vh - 67px) !important;
  }

  .full-wrapper .full {
    min-height: calc(100vh - 168px) !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/chart/components/view/customize/SkccChartView.vue